import { IStyles } from '../../resource';
import theme from '../../theme';

const styles: IStyles = {
  container: (theme) => ({
    margin: '0 auto',
    padding: theme.spacing(6),
  }),
  pageTitle: (theme) => ({
    ...theme.typography.h4,
    marginBottom: theme.spacing(4),
  }),
  title: (theme) => ({
    ...theme.typography.h5,
    marginBottom: theme.spacing(4),
  }),
  description: (theme) => ({
    ...theme.typography.body1,
    marginBottom: theme.spacing(6),
    color: theme.palette.text.secondary,
  }),
  tabs: (theme) => ({
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '1rem',
      fontWeight: 500,
      minHeight: 48,
    },
  }),
  form: (theme) => ({
    width: '100%',
  }),
  table: (theme) => ({
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: theme.spacing(4),
  }),
  th: (theme) => ({
    textAlign: 'left',
    padding: theme.spacing(2, 1),
    ...theme.typography.subtitle2,
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.divider}`,
    maxWidth: '300px'
  }),
  tr: (theme) => ({
   '&:hover': {
        td: {
            backgroundColor: 'transparent !important'
        }
    } 
  }),
  td: (theme) => ({
    padding: theme.spacing(2, 1),
    verticalAlign: 'middle',
    '&:hover': {
        backgroundColor: 'transparent'
    }
  }),
  input: (theme) => ({
    width: 80,
  }),
  saveButton: (theme) => ({
    marginTop: theme.spacing(4),
    padding: theme.spacing(1.5, 6),
  }),
  themeCard: (theme) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[8],
    },
  }),
};

export default styles; 